import { Note, SubmitableNote } from "../types/notes"
import { useReducerAsState } from "./useReducerAsState"
import Notes, { NoteFilters } from "../models/notes.model.";

interface State {
    notes: Array<Note>;
    loading: boolean;
    error: string;
    total: number;
}

interface NotesResult {
    news: Note[];
    total: number;
}

interface NoteDetails {
    news: Note;
}

const useNotes = () => {
    const [state, setState] = useReducerAsState<State>({
        notes: [],
        loading: false,
        error: "",
        total: 0,
    });

    const { notes, total, loading, error } = state

    const fetchNotes = async (props: NoteFilters) => {
       setState({ loading: true, error: "" })
        const response = await Notes.getAll({...props})

       if(response.error){
        setState({ loading: false, error: response.error, notes: [] })
        return
       }

       const result = response.data as NotesResult

       setState({ loading: false, error: "", notes: result.news, total: result.total })
    }

    const findNote = async (noteId: number) => {
        setState({ loading: true, error: "" })
        const response = await Notes.findNote(noteId)

       if(response.error){
        setState({ loading: false, error: response.error})
        return null
       }

       const result = response.data as NoteDetails

       setState({ loading: false, error: "" })
       return result.news
    }

    const createNote = async (note: SubmitableNote): Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await Notes.create(note)

        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

       setState({ loading: false, error: "" })
       return true
    }

    const updateNote = async (note: SubmitableNote): Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await Notes.update(note)

        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

       setState({ loading: false, error: "" })
       return true
    }

    const deleteNote = async (noteId: number) => {
        setState({ loading: true, error: "" })
        const response = await Notes.delete(noteId)

        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

       setState({ loading: false, error: "" })
       return true
    }

    const sendNotification = async (noteId: number) :Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await Notes.notify(noteId)

        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

       setState({ loading: false, error: "" })
       return true
    }

    return { notes, total, loading, error, fetchNotes, findNote, updateNote, createNote, deleteNote, sendNotification }
}

export default useNotes